import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  inlineField: {
    position: 'relative',
    margin: '0, 5px',
    '&.inlineField': {
      maxWidth: 40,
      margin: '0 10px',
      display: 'inline-block',
      '& input': {
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: 5
      }
    }
  }
})

export default useStyles
